import React from 'react';

import { Popover, PopoverProps } from '@mui/material';

export const MenuPopover = ({ children, sx, ...other }: PopoverProps) => {
  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 0,
          mt: 3,
          ml: 0.75,
          width: '232px',
          backgroundImage: 'none',
          border: '1px solid',
          borderColor: (theme) => (theme.palette.mode === 'light' ? 'grey.100' : 'grey.700'),
          '& .MuiMenuItem-root': {
            typography: 'text2',
          },
          ...sx,
        },
      }}
      {...other}
    >
      {children}
    </Popover>
  );
};
